var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{class:_vm.hyperlink ? '' : 'btn btn-primary',attrs:{"title":_vm.title,"to":_vm.routing}},[(_vm.hyperlink)?_c('span',[_vm._v(_vm._s(_vm.title))]):_c('i',{class:_vm.icon})])
}
var staticRenderFns = []

export { render, staticRenderFns }